import { render } from "./Calificacion.vue?vue&type=template&id=7e155188&scoped=true"
import script from "./Calificacion.vue?vue&type=script&lang=js"
export * from "./Calificacion.vue?vue&type=script&lang=js"

import "./Calificacion.vue?vue&type=style&index=0&id=7e155188&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e155188"]])

export default __exports__